import { render, staticRenderFns } from "./classGroupList.vue?vue&type=template&id=c1998c0e"
import script from "./classGroupList.vue?vue&type=script&lang=js"
export * from "./classGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports